import { Link } from "react-router-dom";
import { Reveal, Faq } from "../components/shared";
import { SiteLayout, PageHero, CtaBand, BookBtn, Caps, H2 } from "../components/site";

const FEES = [
  "Some practitioners bulk bill. Ask us who's available.",
  "Pay in full on the day; Medicare returns eligible rebates to your account.",
  "A full fee applies for cancellations with less than 24 hours' notice.",
];
import { FUNDING } from "../content";

export default function Funding() {
  return (
    <SiteLayout testid="funding-page">
      <PageHero eyebrow="Funding & fees" lines={["Funding can be confusing.", "We'll help you understand it."]} sub="We'll explain your options. Eligibility is confirmed before you book.">
        <BookBtn testid="funding-book" />
      </PageHero>
      <section className="max-w-[1360px] mx-auto px-5 sm:px-10 pb-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="funding-cards">
        {FUNDING.map((f, i) => (
          <Reveal key={f.title} delay={i * 0.08} className="rounded-[28px] bg-[#E3E9E4] p-8 even:bg-[#DCE6EC]">
            <f.icon className="w-8 h-8 text-[#3F4A3C]" strokeWidth={1.3} />
            <h3 className="mt-8 font-newsreader text-3xl text-[#3F4A3C]">{f.title}</h3>
            <p className="mt-3 font-jakarta text-sm leading-relaxed text-[#4A4F45]">{f.text}</p>
          </Reveal>
        ))}
      </section>
      <section id="fees" className="scroll-mt-28 border-t border-[#3F4A3C]/10 py-20" data-testid="fees-details">
        <div className="max-w-[1360px] mx-auto px-5 sm:px-10 grid lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-4"><Caps>Fees</Caps><H2 className="mt-5">Fees, rebates & cancellations</H2>
            <ul className="mt-8 space-y-4 font-jakarta text-sm text-[#4A4F45]">{FEES.map((f) => <li key={f}>{f}</li>)}</ul>
            <Link to="/contact" data-testid="fees-contact-link" className="mt-8 block font-jakarta text-sm text-[#3F4A3C] underline underline-offset-4">Questions? Talk to our team</Link>
          </Reveal>
          <Reveal className="lg:col-span-8" delay={0.1}><Faq itemClass="border-[#3F4A3C]/15" triggerClass="font-newsreader text-xl text-[#3F4A3C] py-5" contentClass="font-jakarta text-base text-[#4A4F45] leading-relaxed" /></Reveal>
        </div>
      </section>
      <CtaBand />
    </SiteLayout>
  );
}
